import { isEmpty } from '@execonline-inc/collections';
import { when } from '@execonline-inc/maybe-adapter';
import { always } from '@kofno/piper';
import clsx from 'clsx';
import { Emptyable, Maybe } from 'maybeasy';
import { observer } from 'mobx-react';
import { emptyFragment } from '../../../../../../EmptyFragment';
import {
  FormTemplate,
  SelectionOption,
  fieldValue,
} from '../../../../../../Resource/FormTemplates/Types';
import Button from '../../../../../Form/Button';
import LearningCollectionEditStore from '../../Store';
import { Sharing } from '../../Store/Types';
import BackButton from '../../../LearningCollectionSteps/BackButton';

interface Props {
  store: LearningCollectionEditStore;
  state: Sharing;
}

const isClientGroupsPermission = (type: SelectionOption) => type.value === 'client-groups';

const noClientGroupsSelected = (template: FormTemplate): Maybe<Emptyable> =>
  fieldValue('client_groups', 'multiple-selection', template).andThen(when(isEmpty));

const permissionTypeSelected = (template: FormTemplate): Maybe<SelectionOption> =>
  fieldValue('permission_type', 'single-selection', template);

const canSave = (template: FormTemplate) =>
  permissionTypeSelected(template)
    .andThen(when(isClientGroupsPermission))
    .andThen(always(noClientGroupsSelected(template)))
    .isJust();

function NavButtons({ store, state }: Props) {
  return (
    <div>
      {store.learningCollectionEditFormResource
        .map((resource) => (
          <BackButton
            handleOnClick={() => store.previewing(resource, state.template, state.celebrationPage)}
          />
        ))
        .getOrElse(emptyFragment)}
      <Button
        type="button"
        value="Save and Close"
        onClick={store.finishing}
        className={clsx(
          'ml-4 rounded-md bg-green-700 px-5 py-2.5 text-sm font-semibold text-white',
          'disabled:opacity-75',
        )}
        disabled={canSave(state.template)}
      />
    </div>
  );
}

export default observer(NavButtons);
